import { buttonVariants } from "@nt/ui/recipes";
import { useState } from "react";

export type CopyState = "idle" | "done" | "failed";

/** Copies to the clipboard and says how it went for two seconds. */
export function useCopy(text: string): [CopyState, () => void] {
  const [state, setState] = useState<CopyState>("idle");
  const copy = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => setState("done"))
      .catch(() => setState("failed"));
    setTimeout(() => setState("idle"), 2000);
  };
  return [state, copy];
}

export function CopyButton({
  text,
  label = "Copy",
}: {
  text: string;
  label?: string;
}) {
  const [state, copy] = useCopy(text);
  return (
    <button
      type="button"
      className={buttonVariants({ variant: "secondary", size: "sm" })}
      onClick={copy}
    >
      {state === "done"
        ? "Copied"
        : state === "failed"
          ? "Select and copy by hand"
          : label}
    </button>
  );
}
